import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { VouchersStore } from '@store';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VouchersComponent implements OnInit {
  constructor(public vouchersStore: VouchersStore) {}

  ngOnInit(): void {
    this.vouchersStore.clearState();
  }
}
